import { Routes, RouterModule } from '@angular/router';

const accountRoutes: Routes = [
];

export const AccountExtRouter = RouterModule.forChild(accountRoutes);